import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const sendErrorMail = createApi('sendDataErrorMail', 'POST');

const SendEmailSlice = createSlice({
  name: 'SendEmailSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendErrorMail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendErrorMail.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(sendErrorMail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SendEmailSlice.reducer;